import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { IPackingTypeMySuffix } from 'src/app/shared/model/packing-type-my-suffix.model';
import { PackingTypeMySuffixService } from './packing-type-my-suffix.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';

@Component({
    selector: 'jhi-packing-type-my-suffix-delete-dialog',
    templateUrl: './packing-type-my-suffix-delete-dialog.component.html'
})
export class PackingTypeMySuffixDeleteDialogComponent {
    packingType: IPackingTypeMySuffix;
    futureStatus: boolean = false;
    isConfirmed: boolean = false;

    constructor(
        private packingTypeService: PackingTypeMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private futureRecordService: ConfirmationModelService,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute
    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
    }

    confirmDelete(id: number) {
        this.isConfirmed = true;
        if (this.futureStatus) {
            this.updateExistedFutureRecordStatus(id);
        }
        this.packingTypeService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'packingTypeListModification',
                content: 'Deleted an packingType'
            });
            this.activeModal.dismiss(true);
        });
    }

    updateExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.packingType.id,
            futureDataType: FutureDataType.PACKING_TYPE.valueOf(),
            fromEffectiveDateFormatted: this.packingType.fromEffectiveDate,
            masterStatus : this.packingType.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            console.log(response.body);
        });
    }
}

@Component({
    selector: 'jhi-packing-type-my-suffix-delete-popup',
    template: ''
})
export class PackingTypeMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private languageChangeService: LanguageChangeService
    ) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ packingType }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(PackingTypeMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.packingType = packingType;
                this.ngbModalRef.result.then(
                    result => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/packing-type']));
                        this.ngbModalRef = null;
                    },
                    reason => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/packing-type']));
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
        
       
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
